export type ReplenishButtonType = 'BuyTrafficPage' | 'MobileProfilePage' | 'TariffPage';

const REPLENISH_LINKS = {
  BuyTrafficPage: '/traffic/',
  MobileProfilePage: '/customers/products/mobile/profile/',
  TariffPage: '/traffic/',
  default: '/traffic/',
};

export const getReplenishLink = (
  replenishButtonType?: ReplenishButtonType,
  href?: string,
  isSvyazZ?: boolean,
): string => {
  let link = '';

  if (replenishButtonType) {
    link = REPLENISH_LINKS[replenishButtonType] || REPLENISH_LINKS.default;
  }

  if ((replenishButtonType === 'TariffPage' || !replenishButtonType) && href) {
    link = href;
  }

  if (isSvyazZ && replenishButtonType === 'MobileProfilePage') {
    link += '?buyPackagesPopupOpen';
  }

  return link;
};
